import React, { useState, useEffect } from 'react';
import MultiSelectComponent from '../../components/MultiSelectComponent';
import axiosInstance from '../../api/axios'; import makeAnimated from "react-select/animated";
import { format } from 'date-fns';
import Select from "react-select";
import DatePicker from "react-datepicker";
import { Button, Col, Form, FormCheck, FormControl, FormLabel, FormSelect, Modal, Row, Spinner, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';

const EditModal1 = ({
    isVisible,
    selectedUsers,
    setOpenEditModal,
    setFile,
    setSelectedUsers,
    setCouponData,
    setFromDate,
    setToDate,
    setSelectedCategories,
    setSelectedProducts,
    userCouponId,
    fetchData,
    selectedCategories,
    selectedProducts,
    addonList,
    getProductsList,
    usersInfo,
    handleSelectUsersChange,
    debouncedGetUsersList,
    categoriesData,
    handleSelectCategoryChange,
    productsInfo,
    handleSelectProductChange,
    editOutletData,
    levelsData,
    outletData,
    updatingData,
    setUserCouponId,
    exProductList,
    newSizeAddonsList,
    allAddonList,
    freebieProductsOptions
}) => {

    const animatedComponents = makeAnimated();
    const accessToken = localStorage.getItem("authToken");
    const [editCouponData, setEditCouponData] = useState({
        _id: "",
        isBogoCoupon: false,
        isFreebieCoupon: false,
        freebieProduct: "",
        freebieQuantity: "",
        status: "",
        isSizeUpgradeCoupon: false,
        newSizeUpgradeAddon: "",
        sizeUpgradeAddon: "",
        title: "",
        description: "",
        dailyUsageLimit: "",
        usageType: "",
        couponCode: "",
        discountPercent: "",
        discountAmount: "",
        validityStartDate: "",
        validityEndDate: "",
        startTime: "",
        endTime: "",
        discountPrice: "",
        orderType: "ALL",
        applicableQuantityType: "",
        termsAndConditions: [],
        isComboCategoryCoupon: false,
        maxAddonsAllowed: null,
        maxDiscountAmount: "",
        minOrderAmount: "",
        isMrpDiscount: false,
        excludedAddons: [],
        isHidden: "false"
    });
    const [selectedDaysOfWeek, setSelectedDaysOfWeek] = useState([]);
    const dayOfWeekOptions = [
        { value: 0, label: "Sunday" },
        { value: 1, label: "Monday" },
        { value: 2, label: "Tuesday" },
        { value: 3, label: "Wednesday" },
        { value: 4, label: "Thursday" },
        { value: 5, label: "Friday" },
        { value: 6, label: "Saturday" },
    ];
    const [currentTerm, setCurrentTerm] = useState('');
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [universalCoupon, setUniversalCoupon] = useState(false);
    const [editSelections, setEditSelections] = useState({
        selectedIncludedOutlets: [],
        selectedExcludedOutlets: [],
        selectedApplicableLevels: [],
        primaryComboCategories: [],
        secondaryComboCategories: [],
        selectedDependentCategories: [],
        selectedDependentProducts: [],
        selectedExcludedProducts: [],
        selectedApplicableProducts: [],
        selectedApplicableCategories: []
    });

    const [selectedAddonGroups, setSelectedAddonGroups] = useState([]);
    const [selectedAddonValues, setSelectedAddonValues] = useState([]);
    const [filteredAddonValues, setFilteredAddonValues] = useState([]);
    const [singleSelectedUser, setSingleSelectedUser] = useState(null);
    const [originalCouponData, setOriginalCouponData] = useState(null);
    const [isFetchingCouponDetails, setIsFetchingCouponDetails] = useState(false);

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: '6px',
            borderColor: state.isFocused ? "#2684ff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(38,132,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#2684ff" : "#ced4da",
            },
            minHeight: '38px',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d"
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999
        })
    };

    const handleSingleUserChange = (selectedOption) => {
        setSingleSelectedUser(selectedOption);
    };

    const handleEditSelectAllAddonChange = (type, selectedOptions) => {
        if (type === 'excludedAddonGroups') {
            setSelectedAddonGroups(selectedOptions || []);

            if (selectedOptions && selectedOptions.length > 0) {
                const selectedGroupIds = selectedOptions.map(option => option.value);
                const valuesFromSelectedGroups = allAddonList
                    .filter(addon => selectedGroupIds.includes(addon._id))
                    .flatMap(addon =>
                        addon.addonValues.map(value => ({
                            value: {
                                addonId: addon._id,
                                addValueId: value._id,
                                addonTitle: addon.title,
                                addonValueTitle: value.value
                            },
                            label: `${addon.title} - ${value.value}`
                        }))
                    );
                setFilteredAddonValues(valuesFromSelectedGroups);
            } else {
                setFilteredAddonValues([]);
                setSelectedAddonValues([]);
            }
        }
    };

    const handleEditAddonValueChange = (selectedOptions) => {
        setSelectedAddonValues(selectedOptions || []);

        const excludedAddons = selectedOptions ? selectedOptions.map(option => ({
            addonId: option.value.addonId,
            addonValueId: option.value.addValueId,
            addonTitle: option.value.addonTitle,
            addonValueTitle: option.value.addonValueTitle
        })) : [];

        setEditCouponData(prev => ({
            ...prev,
            excludedAddons: excludedAddons
        }));
    };

    const exProductsInfo = exProductList.map((pro) => ({
        value: pro?._id,
        label: `${pro?.name}`
    }));

    const assignExistingData = async (data) => {
        if (!data) return;

        console.log("Edit Modal Data:", data);
        setOriginalCouponData(data);

        // Set the user-coupon allocation ID
        setUserCouponId(data?.userCouponAllocationId);

        // Handle user selection
        if (data?.userDetails) {
            const singleUserOption = {
                value: data.userDetails._id || data.userDetails.id,
                label: `${data.userDetails.name} (${data.userDetails.email})`
            };
            setSingleSelectedUser(singleUserOption);
        }

        // Parse dates
        const formattedStartDate = data?.coupon?.validityStartDate ? new Date(data?.coupon?.validityStartDate) : null;
        const formattedEndDate = data?.coupon?.validityEndDate ? new Date(data?.coupon?.validityEndDate) : null;

        // Initialize multi-select values from coupon data
        const initializeMultiSelectValues = () => {
            // Initialize outlets
            const includedOutlets = data?.coupon?.includedOutlets?.map(outlet => ({
                value: outlet._id,
                label: `${outlet.name} (${outlet.city})`
            })) || [];

            const excludedOutlets = data?.coupon?.excludedOutlets?.map(outlet => ({
                value: outlet._id,
                label: `${outlet.name} (${outlet.city})`
            })) || [];

            // Initialize levels
            const applicableLevels = data?.coupon?.applicableLevels?.map(level => ({
                value: level._id,
                label: `${level.sequenceNo}. ${level.title}`
            })) || [];

            // Initialize categories and products
            const applicableCategories = data?.coupon?.applicableCategories?.map(cat => ({
                value: cat._id,
                label: cat.name
            })) || [];

            const applicableProducts = data?.coupon?.applicableProducts?.map(product => ({
                value: product._id,
                label: product.name
            })) || [];

            const excludedProducts = data?.coupon?.excludedProducts?.map(product => ({
                value: product._id,
                label: product.name
            })) || [];

            const dependentCategories = data?.coupon?.dependantCategories?.map(cat => ({
                value: cat._id,
                label: cat.name
            })) || [];

            const dependentProducts = data?.coupon?.dependantProducts?.map(product => ({
                value: product._id,
                label: product.name
            })) || [];

            // Initialize combo categories
            const primaryComboCategories = data?.coupon?.primaryComboCategories?.map(cat => ({
                value: cat._id,
                label: cat.name
            })) || [];

            const secondaryComboCategories = data?.coupon?.secondaryComboCategories?.map(cat => ({
                value: cat._id,
                label: cat.name
            })) || [];

            // Initialize excluded addons
            const excludedAddons = data?.coupon?.excludedAddons || [];
            const addonGroups = [];
            const addonValues = [];

            if (excludedAddons.length > 0 && allAddonList.length > 0) {
                // Group addons by addonId
                const groupedByAddonId = excludedAddons.reduce((acc, addon) => {
                    if (!acc[addon.addonId]) {
                        acc[addon.addonId] = [];
                    }
                    acc[addon.addonId].push(addon);
                    return acc;
                }, {});

                // Create addon group selections
                Object.keys(groupedByAddonId).forEach(addonId => {
                    const addon = allAddonList.find(a => a._id === addonId);
                    if (addon) {
                        addonGroups.push({
                            value: addon._id,
                            label: addon.title
                        });

                        // Create addon value selections
                        groupedByAddonId[addonId].forEach(addonValue => {
                            addonValues.push({
                                value: {
                                    addonId: addon._id,
                                    addValueId: addonValue.addonValueId,
                                    addonTitle: addon.title,
                                    addonValueTitle: addonValue.addonValueTitle
                                },
                                label: `${addon.title} - ${addonValue.addonValueTitle}`
                            });
                        });
                    }
                });
            }

            setEditSelections({
                selectedIncludedOutlets: includedOutlets,
                selectedExcludedOutlets: excludedOutlets,
                selectedApplicableLevels: applicableLevels,
                selectedApplicableCategories: applicableCategories,
                selectedApplicableProducts: applicableProducts,
                selectedExcludedProducts: excludedProducts,
                selectedDependentCategories: dependentCategories,
                selectedDependentProducts: dependentProducts,
                primaryComboCategories: primaryComboCategories,
                secondaryComboCategories: secondaryComboCategories
            });

            setSelectedAddonGroups(addonGroups);
            setSelectedAddonValues(addonValues);
            setFilteredAddonValues(addonValues);
        };

        // Call initialization
        initializeMultiSelectValues();
        const isUniversal =
            data?.coupon?.discountPercent &&
            data?.coupon?.applicableCategories?.length > 0 &&
            (!data?.coupon?.applicableProducts || data?.coupon?.applicableProducts?.length === 0);

        if (isUniversal) {
            setUniversalCoupon(true);
        }
        // Populate the day-of-week multi-select from the array coming back from the API
        if (Array.isArray(data?.coupon?.dayOfWeek) && data.coupon.dayOfWeek.length > 0) {
            setSelectedDaysOfWeek(
                data.coupon.dayOfWeek.map((d) => ({
                    value: d,
                    label: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][d],
                }))
            );
        } else {
            setSelectedDaysOfWeek([]);
        }

        // Fallback to basic data if coupon details fetch fails
        setEditCouponData({
            _id: data?.coupon?._id,
            title: data?.coupon?.title || "",
            isHidden: data?.coupon?.isHidden || "false",
            couponCode: data?.coupon?.couponCode || "",
            description: data?.coupon?.description || "",
            validityStartDate: formattedStartDate,
            validityEndDate: formattedEndDate,
            startTime: data?.coupon?.startTime || "",
            dailyUsageLimit: data?.coupon?.dailyUsageLimit || "",
            isFreebieCoupon: data?.coupon?.isFreebieCoupon || false,
            freebieProduct: data?.coupon?.freebieProduct || "",
            freebieQuantity: data?.coupon?.freebieQuantity || "",
            endTime: data?.coupon?.endTime || "",
            termsAndConditions: data?.coupon?.termsAndConditions || [],
            isComboCategoryCoupon: data?.coupon?.isComboCategoryCoupon || false,
            isMrpDiscount: data?.coupon?.isMrpDiscount || false,
            usageType: data?.coupon?.usageType || "ONE-TIME",
            isCouponAllocated: true,
            orderType: data?.coupon?.orderType || "ALL",
            status: data?.coupon?.status || "ACTIVE",
            excludedAddons: data?.coupon?.excludedAddons || [],
            discountAmount: data?.coupon?.discountAmount || "",
            discountPercent: data?.coupon?.discountPercent || "",
            maxDiscountAmount: data?.coupon?.maxDiscountAmount || "",
            discountPrice: data?.coupon?.discountPrice || "",
            minOrderAmount: data?.coupon?.minOrderAmount || "",
            maxAddonsAllowed: data?.coupon?.maxAddonsAllowed || null,
            applicableQuantityType: data?.coupon?.applicableQuantityType || "",
            isBogoCoupon: data?.coupon?.isBogoCoupon || false,
            newSizeUpgradeAddon: data?.coupon?.newSizeUpgradeAddon || "",
            isSizeUpgradeCoupon: !!data?.coupon?.newSizeUpgradeAddon
        });
    };

    const handleChange = (key, value) => {
        setEditSelections((prev) => ({
            ...prev,
            [key]: value,
        }));

        if (key === "selectedApplicableCategories") {
            getProductsList(value);
        }
    };

    const addEditTerm = () => {
        if (!currentTerm.trim()) return;
        setEditCouponData((prevData) => ({
            ...prevData,
            termsAndConditions: Array.isArray(prevData.termsAndConditions)
                ? [...prevData.termsAndConditions, currentTerm]
                : [currentTerm],
        }));
        setCurrentTerm('');
    };

    const removeEditTerm = (index) => {
        setEditCouponData((prevData) => ({
            ...prevData,
            termsAndConditions: Array.isArray(prevData.termsAndConditions)
                ? prevData.termsAndConditions.filter((_, i) => i !== index)
                : [],
        }));
    };

    const handleEditValidStartDateChange = (date) => {
        if (date) {
            setEditCouponData((prev) => ({
                ...prev,
                validityStartDate: date,
            }));
        }
    };

    const handleEditValidEndDateChange = (date) => {
        if (date) {
            setEditCouponData((prev) => ({
                ...prev,
                validityEndDate: date,
            }));
        }
    };

    const handleEditInputChange = (e) => {
        const { name, value, type } = e.target;

        setEditCouponData((prev) => ({
            ...prev,
            [name]: type === "number" ? parseFloat(value) || "" : value,
        }));
    };

    // Old
    // const handleCheckboxChange = (field) => (e) => {
    //     // Reset related fields when changing coupon type
    //     if (field === "isFreebieCoupon" && e.target.checked) {
    //         setEditCouponData(prev => ({
    //             ...prev,
    //             isFreebieCoupon: true,
    //             isBogoCoupon: false,
    //             isSizeUpgradeCoupon: false,
    //             isComboCategoryCoupon: false,
    //             isMrpDiscount: false,
    //             discountAmount: "",
    //             discountPercent: "",
    //             discountPrice: ""
    //         }));
    //     } else if (field === "isBogoCoupon" && e.target.checked) {
    //         setEditCouponData(prev => ({
    //             ...prev,
    //             isBogoCoupon: true,
    //             isFreebieCoupon: false,
    //             isSizeUpgradeCoupon: false,
    //             isComboCategoryCoupon: false,
    //             isMrpDiscount: false,
    //             discountAmount: "",
    //             discountPercent: "",
    //             discountPrice: "",
    //             freebieProduct: "",
    //             freebieQuantity: ""
    //         }));
    //     } else {
    //         setEditCouponData(prev => ({
    //             ...prev,
    //             [field]: e.target.checked
    //         }));
    //     }
    // };

    const handleCheckboxChange = (field) => (e) => {
        // Handle universal coupon separately since it's just a UI flag
        if (field === "isUniversalCoupon") {
            const isChecked = e.target.checked;
            setUniversalCoupon(isChecked);

            if (isChecked) {
                // When universal coupon is checked, clear applicable products
                setEditCouponData(prev => ({
                    ...prev,
                    discountPercent: prev.discountPercent || "", // Keep discount if it exists
                    discountAmount: "", // Clear flat discount
                    discountPrice: "" // Clear discount price
                }));

                // Clear applicable products selection
                setEditSelections(prev => ({
                    ...prev,
                    selectedApplicableProducts: []
                }));
            }

            // Don't update editCouponData for universal coupon
            return;
        }

        // Reset all other coupon types when one is selected (mutually exclusive)
        const currentUsers = singleSelectedUser;

        // If checking a new coupon type, reset all others
        if (e.target.checked) {
            setEditCouponData(prev => ({
                ...prev,
                // Reset all coupon type flags (except universal which is UI-only)
                isBogoCoupon: field === "isBogoCoupon",
                isSizeUpgradeCoupon: field === "isSizeUpgradeCoupon",
                isComboCategoryCoupon: field === "isComboCategoryCoupon",
                isMrpDiscount: field === "isMrpDiscount",
                isFreebieCoupon: field === "isFreebieCoupon",

                // Reset discount fields if switching to a coupon type that doesn't use them
                ...(field !== "isFreebieCoupon" && field !== "isBogoCoupon" && field !== "isSizeUpgradeCoupon" ? {} : {
                    discountPercent: "",
                    discountAmount: "",
                    discountPrice: "",
                    maxDiscountAmount: ""
                }),

                // Reset freebie fields if not freebie coupon
                ...(field !== "isFreebieCoupon" ? {
                    freebieProduct: "",
                    freebieQuantity: ""
                } : {}),

                // Reset size upgrade fields if not size upgrade
                ...(field !== "isSizeUpgradeCoupon" ? {
                    newSizeUpgradeAddon: ""
                } : {})
            }));

            // Reset universal coupon flag if checking another type
            if (field !== "isUniversalCoupon") {
                setUniversalCoupon(false);
            }
        } else {
            // If unchecking, just update that specific field
            setEditCouponData(prev => ({
                ...prev,
                [field]: false
            }));
        }
    };

    const submitEditForm = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);

        // Validate user selection
        if (!singleSelectedUser || !singleSelectedUser.value) {
            toast.error("Please select a user", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
            setIsEditBtnLoading(false);
            return;
        }

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            // Prepare data for API
            const selectedIncludedOutlets = editSelections?.selectedIncludedOutlets?.map((option) => option.value) || [];
            const selectedExcludedOutlets = editSelections?.selectedExcludedOutlets?.map((option) => option.value) || [];
            const selectedApplicableLevels = editSelections?.selectedApplicableLevels?.map((option) => option.value) || [];
            const selectedPrimaryComboCategories = editSelections?.primaryComboCategories?.map((option) => option.value) || [];
            const selectedSecondaryComboCategories = editSelections?.secondaryComboCategories?.map((option) => option.value) || [];
            const selectedDependentCategories = editSelections?.selectedDependentCategories?.map((option) => option.value) || [];
            const selectedDependentProducts = editSelections?.selectedDependentProducts?.map((option) => option.value) || [];
            const selectedExcludedProducts = editSelections?.selectedExcludedProducts?.map((option) => option.value) || [];
            const selectedApplicableProducts = editSelections?.selectedApplicableProducts?.map((option) => option.value) || [];
            const selectedApplicableCategories = editSelections?.selectedApplicableCategories?.map((option) => option.value) || [];
const selectedDaysOfWeekValues = selectedDaysOfWeek?.map((day) => day.value) || [];

            // Validate required fields
            if (!editCouponData.title || !editCouponData.title.trim()) {
                toast.error("Title is required", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                setIsEditBtnLoading(false);
                return;
            }

            if (!editCouponData.couponCode || !editCouponData.couponCode.trim()) {
                toast.error("Coupon Code is required", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                setIsEditBtnLoading(false);
                return;
            }

            // Validate freebie coupon
            if (editCouponData.isFreebieCoupon) {
                if (!editCouponData.freebieProduct) {
                    toast.error("Please select a freebie product", {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "light",
                    });
                    setIsEditBtnLoading(false);
                    return;
                }
                if (!editCouponData.freebieQuantity || editCouponData.freebieQuantity <= 0) {
                    toast.error("Please enter a valid freebie quantity", {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "light",
                    });
                    setIsEditBtnLoading(false);
                    return;
                }
            }

            // Validate discount fields for non-freebie coupons
            if (!editCouponData.isFreebieCoupon && !editCouponData.isBogoCoupon && !editCouponData.isSizeUpgradeCoupon) {
                const hasDiscount = editCouponData.discountPercent || editCouponData.discountAmount || editCouponData.discountPrice;
                if (!hasDiscount) {
                    toast.error("Please enter discount amount, percentage, or price", {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "light",
                    });
                    setIsEditBtnLoading(false);
                    return;
                }
            }

            // Prepare coupon update data
            const couponUpdateData = {
                _id: editCouponData._id,
                title: editCouponData.title,
                isHidden: editCouponData.isHidden,
                couponCode: editCouponData.couponCode,
                description: editCouponData.description,
                validityStartDate: editCouponData.validityStartDate ? format(editCouponData.validityStartDate, "yyyy-MM-dd") : null,
                validityEndDate: editCouponData.validityEndDate ? format(editCouponData.validityEndDate, "yyyy-MM-dd") : null,
                dayOfWeek: selectedDaysOfWeekValues.length > 0 ? selectedDaysOfWeekValues : null,
                startTime: editCouponData.startTime || null,
                endTime: editCouponData.endTime || null,
                dailyUsageLimit: editCouponData.dailyUsageLimit || null,
                termsAndConditions: editCouponData.termsAndConditions,
                isComboCategoryCoupon: editCouponData.isComboCategoryCoupon,
                isMrpDiscount: editCouponData.isMrpDiscount,
                usageType: editCouponData.usageType,
                orderType: editCouponData.orderType,
                status: editCouponData.status,
                excludedAddons: editCouponData.excludedAddons || [],
                discountAmount: editCouponData.discountAmount || null,
                discountPercent: editCouponData.discountPercent || null,
                maxDiscountAmount: editCouponData.maxDiscountAmount || null,
                discountPrice: editCouponData.discountPrice || null,
                minOrderAmount: editCouponData.minOrderAmount || null,
                maxAddonsAllowed: editCouponData.maxAddonsAllowed || null,
                applicableQuantityType: editCouponData.applicableQuantityType || null,
                isBogoCoupon: editCouponData.isBogoCoupon,
                newSizeUpgradeAddon: editCouponData.newSizeUpgradeAddon || null,
                isFreebieCoupon: editCouponData.isFreebieCoupon,
                freebieProduct: editCouponData.freebieProduct || null,
                freebieQuantity: editCouponData.freebieQuantity || null,
                isSizeUpgradeCoupon: editCouponData.isSizeUpgradeCoupon,
                // Add arrays only if they have values
                ...(selectedApplicableCategories.length > 0 && { applicableCategories: selectedApplicableCategories }),
                ...(selectedApplicableProducts.length > 0 && { applicableProducts: selectedApplicableProducts }),
                ...(selectedApplicableLevels.length > 0 && { applicableLevels: selectedApplicableLevels }),
                ...(selectedIncludedOutlets.length > 0 && { includedOutlets: selectedIncludedOutlets }),
                ...(selectedExcludedOutlets.length > 0 && { excludedOutlets: selectedExcludedOutlets }),
                ...(selectedPrimaryComboCategories.length > 0 && { primaryComboCategories: selectedPrimaryComboCategories }),
                ...(selectedSecondaryComboCategories.length > 0 && { secondaryComboCategories: selectedSecondaryComboCategories }),
                ...(selectedDependentCategories.length > 0 && { dependantCategories: selectedDependentCategories }),
                ...(selectedDependentProducts.length > 0 && { dependantProducts: selectedDependentProducts }),
                ...(selectedExcludedProducts.length > 0 && { excludedProductList: selectedExcludedProducts })
            };

            // Clean up empty arrays and null values
            Object.keys(couponUpdateData).forEach((key) => {
                if (Array.isArray(couponUpdateData[key]) && couponUpdateData[key].length === 0) {
                    delete couponUpdateData[key];
                }
                if (couponUpdateData[key] === null || couponUpdateData[key] === undefined || couponUpdateData[key] === "") {
                    delete couponUpdateData[key];
                }
            });

            console.log("Updating coupon with data:", couponUpdateData);

            // Update coupon
            const couponResponse = await axiosInstance.put("coupons", couponUpdateData, { headers });

            if (couponResponse?.data?.status === true) {
                const updatedCouponId = couponResponse?.data?.data?.updatedCoupon?._id;

                // Now update the user-coupon allocation
                const allocationData = {
                    _id: userCouponId, // The allocation ID
                    user: singleSelectedUser.value,
                    coupon_id: updatedCouponId || editCouponData._id
                };

                console.log("Updating allocation with data:", allocationData);

                const allocationResponse = await axiosInstance.put("user-coupon-allocation", allocationData, { headers });

                if (allocationResponse?.data?.status === true) {
                    toast.success("Coupon updated successfully!", {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "light",
                    });
                    handleCloseEditModal();
                    fetchData();
                }
            }
        } catch (error) {
            console.error("Update error:", error);
            let errorMessage = "Failed to update coupon";

            if (error.response) {
                if (error.response?.status === 406) {
                    errorMessage = error.response?.data?.error?.message || error.response?.data?.error;
                } else if (error.response?.status === 404 || error.response?.status === 412) {
                    errorMessage = error.response?.data?.data?.title || error.response?.data?.error;
                } else if (error.response?.status === 500) {
                    errorMessage = error.response?.data?.error;
                }

                console.error("Error response:", error.response.data);
            }

            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    const handleCloseEditModal = () => {
        setOpenEditModal(false);
        resetEditForm();
    };

    const resetEditForm = () => {
        setEditCouponData({
            _id: "",
            isBogoCoupon: false,
            isFreebieCoupon: false,
            freebieProduct: "",
            freebieQuantity: "",
            status: "",
            isSizeUpgradeCoupon: false,
            newSizeUpgradeAddon: "",
            sizeUpgradeAddon: "",
            title: "",
            description: "",
            dailyUsageLimit: "",
            usageType: "",
            couponCode: "",
            discountPercent: "",
            discountAmount: "",
            validityStartDate: "",
            validityEndDate: "",
            startTime: "",
            endTime: "",
            discountPrice: "",
            orderType: "ALL",
            applicableQuantityType: "",
            termsAndConditions: [],
            isComboCategoryCoupon: false,
            maxAddonsAllowed: null,
            maxDiscountAmount: "",
            minOrderAmount: "",
            isMrpDiscount: false,
            excludedAddons: [],
            isHidden: "false"
        });
        setEditSelections({
            selectedIncludedOutlets: [],
            selectedExcludedOutlets: [],
            selectedApplicableLevels: [],
            primaryComboCategories: [],
            secondaryComboCategories: [],
            selectedDependentCategories: [],
            selectedDependentProducts: [],
            selectedExcludedProducts: [],
            selectedApplicableProducts: [],
            selectedApplicableCategories: []
        });
        setCurrentTerm('');
        setSingleSelectedUser(null);
        setSelectedAddonGroups([]);
        setSelectedAddonValues([]);
        setFilteredAddonValues([]);
        setOriginalCouponData(null);
        setSelectedDaysOfWeek([]);
    };

    useEffect(() => {
        if (updatingData && isVisible) {
            assignExistingData(updatingData);
        }
    }, [updatingData, isVisible, allAddonList]);

    const checkboxes = [
        { id: "isBogoCoupon", label: "Bogo Coupon", field: "isBogoCoupon", icon: "ri-shopping-basket-fill" },
        { id: "isuniversalCoupon", label: "Universal Coupon", field: "isUniversalCoupon", icon: "ri-global-line" },
        { id: "isSizeUpgradeCoupon", label: "Size Upgrade", field: "isSizeUpgradeCoupon", icon: "ri-arrow-up-line" },
        { id: "isComboCategoryCoupon", label: "Combo Coupon", field: "isComboCategoryCoupon", icon: "ri-links-line" },
        { id: "isMRPCoupon", label: "MRP Coupon", field: "isMrpDiscount", icon: "ri-price-tag-3-line" },
        { id: "isFreebieCoupon", label: "Freebie Coupon", field: "isFreebieCoupon", icon: "ri-gift-line" },
    ];

    return (
        <Modal
            size="xl"
            centered
            show={isVisible}
            onHide={handleCloseEditModal}
            dialogClassName="modal-fullscreen-lg-down"
        >
            <Modal.Header closeButton className="bg-light">
                <Modal.Title className="fw-bold">
                    <i className="ri-edit-line me-2 text-primary"></i>
                    Edit Coupon Allocation
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={submitEditForm}>
                <Modal.Body className="p-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    {isFetchingCouponDetails ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2 text-muted">Loading coupon details...</p>
                        </div>
                    ) : (
                        <>
                            {/* <div className="alert alert-info mb-4">
                                <i className="ri-information-line me-2"></i>
                                Edit the coupon details and user allocation below. 
                                <strong> Coupon ID:</strong> {editCouponData._id}
                            </div> */}

                            <Row className="g-3">
                                {/* User Selection */}
                                <Col md={12} className="mb-3">
                                    <Card className="border">
                                        <Card.Body>
                                            <FormLabel className="fw-semibold">
                                                <i className="ri-user-line me-2"></i>
                                                Select User <span className="text-danger">*</span>
                                            </FormLabel>
                                            <Select
                                                isClearable
                                                components={animatedComponents}
                                                options={usersInfo}
                                                value={singleSelectedUser}
                                                onChange={handleSingleUserChange}
                                                onInputChange={(query) => {
                                                    debouncedGetUsersList(query);
                                                }}
                                                placeholder="Search and select user..."
                                                styles={customStyles}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 6,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#e7f1ff",
                                                        primary: "#2684ff",
                                                    },
                                                })}
                                                required
                                            />
                                            {singleSelectedUser && (
                                                <div className="mt-2">
                                                    <small className="text-success">
                                                        <i className="ri-check-line me-1"></i>
                                                        Selected: {singleSelectedUser.label}
                                                    </small>
                                                </div>
                                            )}
                                        </Card.Body>
                                    </Card>
                                </Col>

                                {/* Coupon Type Selection */}
                                <Col md={12} className="mb-3">
                                    <Card className="border">
                                        <Card.Body>
                                            <FormLabel className="fw-semibold mb-3">
                                                <i className="ri-coupon-3-line me-2 text-primary"></i>
                                                Coupon Type
                                            </FormLabel>
                                            <Row className="g-3">
                                                {checkboxes?.map(({ id, label, field, icon }) => (
                                                    <Col md={2} key={id}>
                                                        <div className="form-check card-option">
                                                            <FormCheck
                                                                type="checkbox"
                                                                id={id}
                                                                label={
                                                                    <div className="d-flex flex-column align-items-center">
                                                                        <i className={`${icon} fs-4 mb-2 ${
                                                                            // For universal coupon, check the universalCoupon state
                                                                            field === "isUniversalCoupon"
                                                                                ? (universalCoupon ? 'text-primary' : 'text-muted')
                                                                                : (editCouponData[field] ? 'text-primary' : 'text-muted')
                                                                            }`}></i>
                                                                        <span className="small">{label}</span>
                                                                    </div>
                                                                }
                                                                checked={
                                                                    // For universal coupon, check the universalCoupon state
                                                                    field === "isUniversalCoupon"
                                                                        ? universalCoupon
                                                                        : editCouponData[field]
                                                                }
                                                                onChange={handleCheckboxChange(field)}
                                                                className={`custom-checkbox fw-semibold ${field === "isUniversalCoupon"
                                                                    ? (universalCoupon ? 'active' : '')
                                                                    : (editCouponData[field] ? 'active' : '')
                                                                    }`}
                                                            />
                                                        </div>
                                                    </Col>
                                                ))}
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                {/* Basic Information */}
                                <Col md={4}>
                                    <div className="form-floating">
                                        <FormControl
                                            placeholder="Title"
                                            name="title"
                                            value={editCouponData.title || ""}
                                            onChange={handleEditInputChange}
                                            required
                                        />
                                        <FormLabel>
                                            Title <span className="text-danger">*</span>
                                        </FormLabel>
                                    </div>
                                </Col>

                                <Col md={4}>
                                    <div className="form-floating">
                                        <FormControl
                                            placeholder="Coupon Code"
                                            name="couponCode"
                                            value={editCouponData.couponCode || ""}
                                            onChange={handleEditInputChange}
                                            required
                                        />
                                        <FormLabel>
                                            Coupon Code <span className="text-danger">*</span>
                                        </FormLabel>
                                    </div>
                                </Col>

                                <Col md={4}>
                                    <div className="form-floating">
                                        <FormSelect
                                            name="status"
                                            value={editCouponData.status}
                                            onChange={handleEditInputChange}
                                            required
                                        >
                                            <option value="">Select Status</option>
                                            <option value="ACTIVE">ACTIVE</option>
                                            <option value="INACTIVE">INACTIVE</option>
                                        </FormSelect>
                                        <FormLabel>
                                            Status <span className="text-danger">*</span>
                                        </FormLabel>
                                    </div>
                                </Col>

                                {/* Usage Type & Order Type */}
                                <Col md={3}>
                                    <div className="form-floating">
                                        <FormSelect
                                            name="usageType"
                                            value={editCouponData.usageType || "ONE-TIME"}
                                            onChange={handleEditInputChange}
                                            required
                                        >
                                            <option value="">Select Usage Type</option>
                                            <option value="ONE-TIME">ONE-TIME</option>
                                            <option value="MULTIPLE">MULTIPLE</option>
                                        </FormSelect>
                                        <FormLabel>
                                            Usage Type <span className="text-danger">*</span>
                                        </FormLabel>
                                    </div>
                                </Col>

                                <Col md={3}>
                                    <div className="form-floating">
                                        <FormSelect
                                            name="orderType"
                                            value={editCouponData.orderType || "ALL"}
                                            onChange={handleEditInputChange}
                                        >
                                            <option value="ALL">ALL</option>
                                            <option value="DELIVERY">DELIVERY</option>
                                            <option value="PICKUP">PICK-UP</option>
                                        </FormSelect>
                                        <FormLabel>Order Type</FormLabel>
                                    </div>
                                </Col>

                                <Col md={3}>
                                    <div className="form-floating">
                                        <FormControl
                                            min={0}
                                            placeholder="Daily Usage Limit"
                                            name="dailyUsageLimit"
                                            value={editCouponData.dailyUsageLimit || ""}
                                            onChange={handleEditInputChange}
                                        />
                                        <FormLabel>Daily Usage Limit</FormLabel>
                                    </div>
                                </Col>

                                <Col md={3}>
                                    <div className="form-floating">
                                        <FormSelect
                                            name="isHidden"
                                            value={editCouponData.isHidden || "false"}
                                            onChange={handleEditInputChange}
                                        >
                                            <option value="false">Visible</option>
                                            <option value="true">Hidden</option>
                                        </FormSelect>
                                        <FormLabel>Visibility</FormLabel>
                                    </div>
                                </Col>

                                {/* Dates */}
                                <Col md={3}>
                                    <FormLabel>Start Date</FormLabel>
                                    <div className="form-floating">
                                        <DatePicker
                                            onChange={handleEditValidStartDateChange}
                                            placeholderText="Start Date"
                                            className="form-control"
                                            dateFormat="dd/MM/yyyy"
                                            selected={editCouponData.validityStartDate}
                                            minDate={new Date()}
                                        />
                                    </div>
                                </Col>

                                <Col md={3}>
                                    <FormLabel>End Date</FormLabel>
                                    <div className="form-floating">
                                        <DatePicker
                                            selected={editCouponData.validityEndDate}
                                            onChange={handleEditValidEndDateChange}
                                            placeholderText="End Date"
                                            className="form-control"
                                            dateFormat="dd/MM/yyyy"
                                            minDate={editCouponData.validityStartDate || new Date()}
                                        />
                                    </div>
                                </Col>

                                <Col md={3}>
                                    <div className="form-floating">
                                        <FormControl
                                            type="time"
                                            placeholder="Start Time"
                                            name="startTime"
                                            value={editCouponData.startTime}
                                            onChange={handleEditInputChange}
                                        />
                                        <FormLabel>Start Time</FormLabel>
                                    </div>
                                </Col>

                                <Col md={3}>
                                    <div className="form-floating">
                                        <FormControl
                                            type="time"
                                            placeholder="End Time"
                                            name="endTime"
                                            value={editCouponData.endTime}
                                            onChange={handleEditInputChange}
                                        />
                                        <FormLabel>End Time</FormLabel>
                                    </div>
                                </Col>

                                {/* Day of Week */}
                                {/* Day of Week */}
<Col md={4}>
    <FormLabel className="fw-semibold">Applicable Day(s)</FormLabel>
    <Select
        isMulti
        components={animatedComponents}
        options={dayOfWeekOptions}
        value={selectedDaysOfWeek}
        onChange={(selected) => setSelectedDaysOfWeek(selected || [])}
        placeholder="Select day(s) (leave empty for any day)"
        closeMenuOnSelect={false}
        styles={customStyles}
        theme={(theme) => ({
            ...theme,
            borderRadius: 6,
            colors: {
                ...theme.colors,
                primary25: "#e7f1ff",
                primary: "#2684ff",
            },
        })}
    />
</Col>

                                {/* Discount Fields */}
                                {!editCouponData.isFreebieCoupon && !editCouponData.isBogoCoupon && !editCouponData.isSizeUpgradeCoupon && (
                                    <>
                                        <Col md={2}>
                                            <div className="form-floating">
                                                <FormControl
                                                    min={0}
                                                    max={100}
                                                    disabled={editCouponData?.discountAmount || editCouponData?.discountPrice}
                                                    placeholder="Discount Percent"
                                                    type="number"
                                                    name="discountPercent"
                                                    value={editCouponData.discountPercent || ""}
                                                    onChange={handleEditInputChange}
                                                />
                                                <FormLabel>Discount %</FormLabel>
                                            </div>
                                        </Col>

                                        <Col md={2}>
                                            <div className="form-floating">
                                                <FormControl
                                                    min={0}
                                                    disabled={editCouponData.isBogoCoupon || editCouponData.isSizeUpgradeCoupon || editCouponData.discountAmount || editCouponData.discountPrice}
                                                    placeholder="Max. Discount"
                                                    type="number"
                                                    name="maxDiscountAmount"
                                                    value={editCouponData.maxDiscountAmount}
                                                    onChange={handleEditInputChange}
                                                />
                                                <FormLabel>Max Discount</FormLabel>
                                            </div>
                                        </Col>

                                        <Col md={2}>
                                            <div className="form-floating">
                                                <FormControl
                                                    min={0}
                                                    step={0.01}
                                                    disabled={editCouponData?.discountPercent || editCouponData?.discountPrice}
                                                    placeholder="Discount Amount"
                                                    type="number"
                                                    name="discountAmount"
                                                    value={editCouponData.discountAmount || ""}
                                                    onChange={handleEditInputChange}
                                                />
                                                <FormLabel>Flat Discount</FormLabel>
                                            </div>
                                        </Col>

                                        <Col md={2}>
                                            <div className="form-floating">
                                                <FormControl
                                                    min={0}
                                                    step={0.01}
                                                    disabled={editCouponData?.discountAmount || editCouponData?.discountPercent}
                                                    placeholder="Discount Price"
                                                    type="number"
                                                    name="discountPrice"
                                                    value={editCouponData.discountPrice || ""}
                                                    onChange={handleEditInputChange}
                                                />
                                                <FormLabel>Discount Price</FormLabel>
                                            </div>
                                        </Col>
                                    </>
                                )}

                                {/* Freebie Fields */}
                                {editCouponData.isFreebieCoupon && (
                                    <>
                                        <Col md={6}>
                                            <div className="form-floating">
                                                <Select
                                                    name="freebieProduct"
                                                    options={freebieProductsOptions || []}
                                                    value={freebieProductsOptions?.find(option => option.value === editCouponData.freebieProduct) || null}
                                                    onChange={(selectedOption) => {
                                                        setEditCouponData(prev => ({
                                                            ...prev,
                                                            freebieProduct: selectedOption ? selectedOption.value : ""
                                                        }));
                                                    }}
                                                    isClearable
                                                    placeholder="Select Freebie Product"
                                                    classNamePrefix="react-select"
                                                    styles={customStyles}
                                                    required
                                                />
                                                <FormLabel>
                                                    Freebie Product <span className="text-danger">*</span>
                                                </FormLabel>
                                            </div>
                                        </Col>

                                        <Col md={2}>
                                            <div className="form-floating">
                                                <FormControl
                                                    type="number"
                                                    min="1"
                                                    name="freebieQuantity"
                                                    value={editCouponData.freebieQuantity || ""}
                                                    onChange={handleEditInputChange}
                                                    placeholder="Quantity"
                                                    required
                                                />
                                                <FormLabel>
                                                    Quantity <span className="text-danger">*</span>
                                                </FormLabel>
                                            </div>
                                        </Col>
                                    </>
                                )}

                                {/* Size Upgrade Addon */}
                                {editCouponData.isSizeUpgradeCoupon && (
                                    <Col md={4}>
                                        <div className="form-floating">
                                            <FormSelect
                                                name="newSizeUpgradeAddon"
                                                value={editCouponData.newSizeUpgradeAddon}
                                                onChange={(e) => setEditCouponData((prev) => ({
                                                    ...prev,
                                                    newSizeUpgradeAddon: e.target.value,
                                                }))}
                                                required
                                            >
                                                <option value="">Select Size Upgrade Addon</option>
                                                {newSizeAddonsList?.map((addon) => (
                                                    <option key={addon._id} value={addon._id}>
                                                        {addon.title} [{addon.identifier}]
                                                    </option>
                                                ))}
                                            </FormSelect>
                                            <FormLabel>
                                                Size Upgrade Addon <span className="text-danger">*</span>
                                            </FormLabel>
                                        </div>
                                    </Col>
                                )}

                                {/* Other Fields */}
                                <Col md={3}>
                                    <div className="form-floating">
                                        <FormControl
                                            min={0}
                                            placeholder="Min. Order Amount"
                                            type="number"
                                            name="minOrderAmount"
                                            value={editCouponData.minOrderAmount}
                                            onChange={handleEditInputChange}
                                        />
                                        <FormLabel>Min. Order Amount</FormLabel>
                                    </div>
                                </Col>

                                <Col md={3}>
                                    <div className="form-floating">
                                        <FormControl
                                            min={0}
                                            placeholder="Max Addons Allowed"
                                            type="number"
                                            name="maxAddonsAllowed"
                                            value={editCouponData.maxAddonsAllowed || ""}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*$/.test(value)) {
                                                    handleEditInputChange(e);
                                                }
                                            }}
                                            disabled={editCouponData.isFreebieCoupon}
                                        />
                                        <FormLabel>Max Addons Allowed</FormLabel>
                                    </div>
                                </Col>

                                <Col md={3}>
                                    <div className="form-floating">
                                        <FormSelect
                                            name="applicableQuantityType"
                                            value={editCouponData.applicableQuantityType || ""}
                                            onChange={handleEditInputChange}
                                            disabled={
                                                editCouponData?.discountPercent ||
                                                editCouponData?.discountAmount ||
                                                editCouponData?.isBogoCoupon ||
                                                editCouponData.isSizeUpgradeCoupon ||
                                                editCouponData?.isMrpDiscount ||
                                                editCouponData.isFreebieCoupon
                                            }
                                        >
                                            <option value="">Select Qty Type</option>
                                            <option value="SINGLE">SINGLE</option>
                                            {!editCouponData?.isComboCategoryCoupon && (
                                                <option value="MULTIPLE">MULTIPLE</option>
                                            )}
                                        </FormSelect>
                                        <FormLabel>Applicable Qty Type</FormLabel>
                                    </div>
                                </Col>

                                <Col md={3}>
                                    <div className="form-floating">
                                        <FormSelect
                                            name="isMrpDiscount"
                                            value={editCouponData.isMrpDiscount}
                                            onChange={handleEditInputChange}
                                            disabled={editCouponData?.isBogoCoupon || editCouponData?.isSizeUpgradeCoupon || editCouponData?.isComboCategoryCoupon || editCouponData.isFreebieCoupon}
                                        >
                                            <option value="false">No</option>
                                            <option value="true">Yes</option>
                                        </FormSelect>
                                        <FormLabel>MRP Discount?</FormLabel>
                                    </div>
                                </Col>

                                {/* Description */}
                                <Col md={12}>
                                    <div className="form-floating">
                                        <FormControl
                                            as="textarea"
                                            rows={3}
                                            placeholder="Description"
                                            name="description"
                                            value={editCouponData.description || ""}
                                            onChange={handleEditInputChange}
                                            style={{ minHeight: '100px' }}
                                        />
                                        <FormLabel>Description</FormLabel>
                                    </div>
                                </Col>

                                {/* Multi-Select Components Section */}
                                <div className="mb-4">
                                    <h6 className="fw-bold mb-3">
                                        <i className="ri-filter-2-line me-2 text-primary"></i>
                                        Advanced Filters & Restrictions
                                    </h6>

                                    <Row className="g-3">
                                        {/* Product & Category Filters */}
                                        <Col md={6}>
                                            <Card className="border h-100">
                                                <Card.Header className="bg-light py-2">
                                                    <h6 className="mb-0">
                                                        <i className="ri-list-check me-2"></i>
                                                        Product & Category Filters
                                                    </h6>
                                                </Card.Header>
                                                <Card.Body>
                                                    <MultiSelectComponent
                                                        label="Applicable Categories"
                                                        placeholder="Select categories"
                                                        value={editSelections.selectedApplicableCategories || []}
                                                        onChange={(value) => handleChange("selectedApplicableCategories", value)}
                                                        options={categoriesData}
                                                        isDisabled={!!editSelections.selectedApplicableProducts?.length || editCouponData?.isComboCategoryCoupon || editCouponData.isFreebieCoupon}
                                                        helpText="Products from these categories will be eligible"
                                                    />

                                                    <MultiSelectComponent
                                                        label="Applicable Products"
                                                        placeholder="Select specific products"
                                                        value={editSelections.selectedApplicableProducts || []}
                                                        onChange={(value) => handleChange("selectedApplicableProducts", value)}
                                                        options={productsInfo}
                                                        isDisabled={!!editSelections.selectedApplicableCategories?.length || editCouponData.isBogoCoupon || editCouponData?.isComboCategoryCoupon || editCouponData.isFreebieCoupon}
                                                        helpText="Only these specific products will be eligible"
                                                    />

                                                    <MultiSelectComponent
                                                        label="Excluded Products"
                                                        placeholder="Select products to exclude"
                                                        value={editSelections.selectedExcludedProducts || []}
                                                        onChange={(value) => handleChange("selectedExcludedProducts", value)}
                                                        options={exProductsInfo}
                                                        helpText="These products will NOT be eligible for the coupon"
                                                    />
                                                </Card.Body>
                                            </Card>
                                        </Col>

                                        {/* Combo Categories */}
                                        {editCouponData?.isComboCategoryCoupon && (
                                            <Col md={6}>
                                                <Card className="border h-100">
                                                    <Card.Header className="bg-light py-2">
                                                        <h6 className="mb-0">
                                                            <i className="ri-links-line me-2"></i>
                                                            Combo Categories
                                                        </h6>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <MultiSelectComponent
                                                            label="Primary Combo Categories"
                                                            placeholder="Select primary categories"
                                                            value={editSelections.primaryComboCategories || []}
                                                            onChange={(value) => handleChange("primaryComboCategories", value)}
                                                            options={categoriesData.filter(
                                                                (category) =>
                                                                    !editSelections.secondaryComboCategories?.some(
                                                                        (cat) => cat.value === category.value
                                                                    )
                                                            )}
                                                            isDisabled={editCouponData.isBogoCoupon || editCouponData?.isSizeUpgradeCoupon || editCouponData?.isMrpDiscount || editCouponData.isFreebieCoupon}
                                                            helpText="Primary categories for combo discounts"
                                                        />

                                                        <MultiSelectComponent
                                                            label="Secondary Combo Categories"
                                                            placeholder="Select secondary categories"
                                                            value={editSelections.secondaryComboCategories || []}
                                                            onChange={(value) => handleChange("secondaryComboCategories", value)}
                                                            options={categoriesData.filter(
                                                                (category) =>
                                                                    !editSelections.primaryComboCategories?.some(
                                                                        (cat) => cat.value === category.value
                                                                    )
                                                            )}
                                                            isDisabled={editCouponData.isBogoCoupon || editCouponData?.isSizeUpgradeCoupon || editCouponData?.isMrpDiscount || editCouponData.isFreebieCoupon}
                                                            helpText="Secondary categories that combine with primary"
                                                        />
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        )}

                                        {/* Outlet Selections */}
                                        <Col md={6}>
                                            <Card className="border h-100">
                                                <Card.Header className="bg-light py-2">
                                                    <h6 className="mb-0">
                                                        <i className="ri-store-line me-2"></i>
                                                        Outlet Restrictions
                                                    </h6>
                                                </Card.Header>
                                                <Card.Body>
                                                    <MultiSelectComponent
                                                        label="Include Outlets"
                                                        placeholder="Select outlets to include"
                                                        options={editOutletData}
                                                        value={editSelections?.selectedIncludedOutlets || []}
                                                        onChange={(value) => handleChange("selectedIncludedOutlets", value)}
                                                        isDisabled={!!editSelections?.selectedExcludedOutlets?.length}
                                                        helpText="Coupon will only work at these outlets"
                                                    />

                                                    <MultiSelectComponent
                                                        label="Exclude Outlets"
                                                        placeholder="Select outlets to exclude"
                                                        options={outletData.filter(
                                                            (outlet) =>
                                                                !editSelections.selectedIncludedOutlets?.some(
                                                                    (includedOutlet) => includedOutlet.value === outlet.value
                                                                )
                                                        )}
                                                        value={editSelections.selectedExcludedOutlets || []}
                                                        onChange={(value) => handleChange("selectedExcludedOutlets", value)}
                                                        isDisabled={!!editSelections?.selectedIncludedOutlets?.length}
                                                        helpText="Coupon will NOT work at these outlets"
                                                    />
                                                </Card.Body>
                                            </Card>
                                        </Col>

                                        {/* User Level & Dependencies */}
                                        <Col md={6}>
                                            <Card className="border h-100">
                                                <Card.Header className="bg-light py-2">
                                                    <h6 className="mb-0">
                                                        <i className="ri-user-settings-line me-2"></i>
                                                        User Level & Dependencies
                                                    </h6>
                                                </Card.Header>
                                                <Card.Body>
                                                    <MultiSelectComponent
                                                        label="Applicable Levels"
                                                        placeholder="Select user levels"
                                                        value={editSelections?.selectedApplicableLevels || []}
                                                        onChange={(value) => handleChange("selectedApplicableLevels", value)}
                                                        options={levelsData}
                                                        helpText="Only users at these levels can use this coupon"
                                                    />

                                                    <MultiSelectComponent
                                                        label="Dependent Products"
                                                        placeholder="Select dependent products"
                                                        value={editSelections.selectedDependentProducts || []}
                                                        onChange={(value) => handleChange("selectedDependentProducts", value)}
                                                        options={productsInfo}
                                                        isDisabled={editCouponData.isBogoCoupon || editCouponData?.isSizeUpgradeCoupon || editCouponData?.isComboCategoryCoupon || editCouponData.isFreebieCoupon}
                                                        helpText="Products that must be in cart for coupon to apply"
                                                    />

                                                    <MultiSelectComponent
                                                        label="Dependent Categories"
                                                        placeholder="Select dependent categories"
                                                        value={editSelections.selectedDependentCategories || []}
                                                        onChange={(value) => handleChange("selectedDependentCategories", value)}
                                                        options={categoriesData}
                                                        isDisabled={editCouponData.isBogoCoupon || editCouponData?.isSizeUpgradeCoupon || editCouponData?.isComboCategoryCoupon || editCouponData.isFreebieCoupon}
                                                        helpText="Categories that must be in cart for coupon to apply"
                                                    />
                                                </Card.Body>
                                            </Card>
                                        </Col>

                                        {/* Addon Exclusions */}
                                        <Col md={12}>
                                            <Card className="border h-100">
                                                <Card.Header className="bg-light py-2">
                                                    <h6 className="mb-0">
                                                        <i className="ri-list-settings-line me-2"></i>
                                                        Addon Exclusions
                                                    </h6>
                                                </Card.Header>
                                                <Card.Body>
                                                    <Row>
                                                        <Col md={6}>
                                                            <div className="mb-3">
                                                                <FormLabel className="fw-semibold">
                                                                    <i className="ri-list-check me-2"></i>
                                                                    Excluding Addon Groups
                                                                </FormLabel>
                                                                <Select
                                                                    components={animatedComponents}
                                                                    isMulti
                                                                    options={allAddonList.map(addon => ({
                                                                        value: addon._id,
                                                                        label: addon.title,
                                                                        icon: addon.icon || "ri-list-settings"
                                                                    }))}
                                                                    value={selectedAddonGroups}
                                                                    onChange={(options) => handleEditSelectAllAddonChange('excludedAddonGroups', options)}
                                                                    className="basic-multi-select"
                                                                    classNamePrefix="select"
                                                                    placeholder="Select addon groups to exclude..."
                                                                    isDisabled={editCouponData.isFreebieCoupon}
                                                                    styles={customStyles}
                                                                    formatOptionLabel={({ label, icon }) => (
                                                                        <div className="d-flex align-items-center">
                                                                            <i className={`${icon || 'ri-list-settings'} me-2`}></i>
                                                                            <span>{label}</span>
                                                                        </div>
                                                                    )}
                                                                />
                                                                <small className="text-muted mt-1 d-block">
                                                                    Select addon groups whose values should be excluded
                                                                </small>
                                                            </div>
                                                        </Col>

                                                        <Col md={6}>
                                                            <div className="mb-3">
                                                                <FormLabel className="fw-semibold">
                                                                    <i className="ri-list-settings-line me-2"></i>
                                                                    Excluding Addon Values
                                                                </FormLabel>
                                                                <Select
                                                                    components={animatedComponents}
                                                                    isMulti
                                                                    options={filteredAddonValues}
                                                                    value={selectedAddonValues}
                                                                    onChange={handleEditAddonValueChange}
                                                                    className="basic-multi-select"
                                                                    classNamePrefix="select"
                                                                    placeholder={
                                                                        selectedAddonGroups.length === 0
                                                                            ? "Select addon groups first"
                                                                            : "Select specific addon values to exclude"
                                                                    }
                                                                    getOptionLabel={(option) => option.label}
                                                                    getOptionValue={(option) => `${option.value.addonId}-${option.value.addValueId}`}
                                                                    isDisabled={selectedAddonGroups.length === 0 || editCouponData.isFreebieCoupon}
                                                                    styles={customStyles}
                                                                />
                                                                <small className="text-muted mt-1 d-block">
                                                                    {selectedAddonValues.length > 0
                                                                        ? `${selectedAddonValues.length} addon value(s) selected`
                                                                        : "No addon values excluded"
                                                                    }
                                                                </small>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                </div>

                                {/* Terms and Conditions */}
                                <Col md={12}>
                                    <Card className="border">
                                        <Card.Body>
                                            <FormLabel className="fw-semibold">
                                                <i className="ri-file-text-line me-2"></i>
                                                Terms & Conditions
                                            </FormLabel>
                                            <div className="d-flex mb-3">
                                                <FormControl
                                                    placeholder="Enter term..."
                                                    value={currentTerm}
                                                    onChange={(e) => setCurrentTerm(e.target.value)}
                                                    className="me-2"
                                                />
                                                <Button
                                                    variant="primary"
                                                    onClick={addEditTerm}
                                                    disabled={!currentTerm.trim()}
                                                >
                                                    <i className="ri-add-line me-1"></i> Add
                                                </Button>
                                            </div>
                                            {editCouponData?.termsAndConditions?.length > 0 && (
                                                <div className="terms-list">
                                                    {editCouponData?.termsAndConditions?.map((term, index) => (
                                                        <div key={index} className="alert alert-light d-flex justify-content-between align-items-center mb-2">
                                                            <span>{term}</span>
                                                            <Button
                                                                variant="outline-danger"
                                                                size="sm"
                                                                onClick={() => removeEditTerm(index)}
                                                            >
                                                                <i className="ri-close-line"></i>
                                                            </Button>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <Button
                        variant="outline-secondary"
                        onClick={handleCloseEditModal}
                        disabled={isEditBtnLoading}
                    >
                        <i className="ri-close-line me-1"></i> Cancel
                    </Button>
                    <Button
                        variant="primary"
                        type="submit"
                        disabled={isEditBtnLoading || isFetchingCouponDetails}
                    >
                        {isEditBtnLoading ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Saving...
                            </>
                        ) : (
                            <>
                                <i className="ri-save-line me-1"></i> Save Changes
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default EditModal1;